/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
// HERO "Larissa" (modelo_busca = 17): abertura da home do modelo "Larissa", no espírito do site de
// referência (monocromático, serifa Lora + Inter), com as cores do tenant via larissa.ts.
//  - HERÓI SÓ DE MÍDIA (nenhum texto sobre ela): vídeo do tenant (desktop) → banner "topo" → capa do
//    vídeo → degradê do modelo; altura calc(100vh - 180px) no desktop e ~46vh no celular, com um
//    degradê de 140px na base;
//  - CARTÃO BRANCO de busca (máx. 1024px, raio 16, sombra) SOBREPOSTO à base do herói: título em
//    serifa (site.frase_busca; reserva "Encontre seu próximo imóvel") e a NOSSA busca direta —
//    "Onde?" (SmartLocationSearch: bairro, cidade, condomínio ou código) com a lupa, Comprar/Alugar em
//    LADRILHOS (selecionado = cor escura do tenant, texto branco), tipo, "valor até", botão primário
//    "Buscar" e o link "Busca avançada".
//  - URL: cidade/tipo/valor saem do useHeroSearch (fonte única); bairro, condomínio e código usam a
//    MESMA rota da busca padrão (/imoveis/<transação>/<cidade>/<bairro>/<condomínio>/<tipo>/<código>)
//    e o mesmo `finalize` do hook (codsite de teste + filial ativa), com o evento Search do Meta.
//  - Índice do "Onde?": montado no 1º foco — cidades e condomínios que a home já tem; os bairros das
//    primeiras cidades chegam em seguida (mesmo serviço `district` dos heros legados).
// prefers-reduced-motion: sem brilho no botão nem transições. Default export = ErrorBoundary com fallback.
import { hifenUrl } from '../../../utils/hifenUrl';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { district } from '../../../services/selectors';
import { normalizaTermo, pareceCodigo } from '../../../utils/buscaLocal';
import { idsDoTexto, opcoesDoTexto, resumoMarcados } from '../../../utils/buscaMultiSelecao';
import type { Sugestao } from '../../../utils/buscaLocal';
import { removerAcentos } from '../../../utils/FunctionsGlobals';
import { getHeroVideoPoster, getTenantVideoCover, useHeroVideoReady } from '../../../utils/heroVideo';
import { genMetaEventId, trackMetaEvent } from '../../../utils/metaPixel';
import DrawerComponent from '../../drawer/DrawerComponent';
import type { HeroSectionProps } from '../../registry/types';
import CardsBusca from '../../shared/cards-busca/CardsBusca';
import CampoSelecaoMulti from '../../shared/hero-search/CampoSelecaoMulti';
import SmartLocationSearch from '../../shared/hero-search/SmartLocationSearch';
import { useHeroSearch } from '../../shared/hero-search/useHeroSearch';
import HeroVideoCover from '../../utils/HeroVideoCover';
import { paletaLarissa, stripHtml, useMovimentoReduzido, varsLarissa } from '../larissa/larissa';
import BuscaAvancadaAurora from '../welcome-aurora/BuscaAvancadaAurora';
import '../larissa/LarissaFonte.module.css';
import styles from './WelcomeLarissa.module.css';
import { usePreviaBuilder } from '../../../lib/previaBuilder';

const TITULO_PADRAO = 'Encontre seu próximo imóvel';
const EXT_VIDEO_RE = /\.(mp4|webm|mov|m4v)(\?|$)/i;
/** referência "livre": sem espaço, 3–24 caracteres, pelo menos 2 dígitos (a listagem por código resolve todas). */
const REFERENCIA_LIVRE = /^(?=(?:.*\d){2})[A-Za-z0-9][A-Za-z0-9:._-]{2,23}$/;
/** bairros: uma consulta por cidade — só as primeiras (as priorizadas do tenant vêm no topo da lista). */
const CIDADES_COM_BAIRROS = 8;

// Milhar com ponto SEM Intl (toLocaleString depende do ICU do runtime → hydration mismatch).
const agrupaMilhar = (digitos: string): string => digitos.replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
/** segmento da rota /imoveis: hífen escapado (a rota usa "-" como campo vazio), barra/interrogação neutralizadas. */
const segmento = (rotulo: unknown, codsite?: unknown): string => {
    const bruto = String(rotulo ?? '').trim();
    return bruto ? hifenUrl(bruto, codsite).replaceAll('/', '-').replaceAll('?', '-') : '-';
};

const comum = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true };
const IconeLupa = () => (
    <svg {...comum} width={18} height={18} strokeWidth={2}>
        <circle cx="11" cy="11" r="7" />
        <line x1="16.5" y1="16.5" x2="21" y2="21" />
    </svg>
);
const IconeSeta = () => (
    <svg {...comum} width={16} height={16} strokeWidth={1.8}>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="13 6 19 12 13 18" />
    </svg>
);
const IconeFiltros = () => (
    <svg {...comum} width={16} height={16} strokeWidth={1.8}>
        <line x1="4" y1="7" x2="20" y2="7" />
        <line x1="4" y1="17" x2="20" y2="17" />
        <circle cx="9" cy="7" r="2.2" fill="#ffffff" />
        <circle cx="15" cy="17" r="2.2" fill="#ffffff" />
    </svg>
);
// ícones dos ladrilhos de transação (traço fino)
const IconeTransacao = ({ valor }: { valor: string }) => {
    if (valor === 'aluguel' || valor === 'locacao')
        return (
            <svg {...comum} width={20} height={20}>
                <circle cx="8" cy="15" r="4" />
                <path d="M11 12l8-8M16 7l3 3M13.5 9.5l2 2" />
            </svg>
        );
    if (valor === 'temporada')
        return (
            <svg {...comum} width={20} height={20}>
                <rect x="4" y="5.5" width="16" height="14.5" rx="2" />
                <path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" />
            </svg>
        );
    return (
        <svg {...comum} width={20} height={20}>
            <path d="M4 11.5L12 5l8 6.5" />
            <path d="M6 10.5V19h12v-8.5" />
            <path d="M10 19v-5h4v5" />
        </svg>
    );
};

const WelcomeLarissaInner: React.FC<HeroSectionProps> = ({ allCities, allTypes, allTransacao, allCompany, site, urlBanner, origin, codsite, codsite2, setActiveDrawer, activeDrawer, favorito, isMobile1, props, allCards }) => {
    const { videoParado } = usePreviaBuilder(); // prévia dos cards do CRM: vídeo parado na capa
    const { transacoes, transacao, setTransacao, cidade, setCidade, tipo, setTipo, dormitorios, setDormitorios, precoMax, setPrecoMax, loading, setLoading, finalize, onSubmit } = useHeroSearch({ site, allCities, allTypes, allTransacao, codsite2, origin });
    const router = useRouter();
    const reduzido = useMovimentoReduzido();

    // ---- busca avançada: POPUP no visual do modelo (Daniel 15/10: "busca avançada não está abrindo popup com o layout
    // padrão ao modelo") — o painel de filtros do Aurora/Horizonte (BuscaAvancadaAurora) com a pele "larissa". A URL final é
    // a do contrato de /imoveis (montarUrlAvancada + finalize do hook) e o evento Search leva o MESMO eventId que a
    // listagem usa na dedup do CAPI (como o Horizonte e o Panorama). ----
    const paleta = paletaLarissa(site);
    const [avancadaAberta, setAvancadaAberta] = useState(false);
    const fecharAvancada = useCallback(() => setAvancadaAberta(false), []);
    const abrirAvancada = () => {
        trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' });
        setAvancadaAberta(true);
    };
    const buscarAvancada = (url: string) => {
        const eventId = genMetaEventId();
        try {
            sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() }));
        } catch {
            /* sessionStorage indisponível */
        }
        trackMetaEvent(site, 'Search', { search_string: 'busca avançada', transaction_type: transacao }, { eventId });
        setAvancadaAberta(false);
        router.push(url).catch(() => undefined);
    };

    // ---- textos do tenant (SSR) ----
    const titulo = useMemo(() => (site?.frase_busca ? stripHtml(site.frase_busca) : '') || TITULO_PADRAO, [site?.frase_busca]);
    const moeda = site?.moeda_tipo || 'R$';

    // ---- mídia: vídeo do tenant (fora do celular) > banner "topo" > capa do vídeo > degradê ----
    const bannerSrc = urlBanner && urlBanner !== 'undefined' && !EXT_VIDEO_RE.test(String(urlBanner)) ? String(urlBanner).replaceAll('"', '') : '';
    const videoSrc = site?.url_video && !isMobile1 ? String(site.url_video).replaceAll('"', '') : '';
    const heroPoster = getHeroVideoPoster(site?.url_video);
    const heroVideoReady = useHeroVideoReady();
    const capaVideo = site?.url_video_poster || heroPoster || getTenantVideoCover(site?.url_video);

    // ---- opções de tipo (nomes repetidos no cadastro entram uma vez: a listagem é por nome) ----
    const opcoesTipo = useMemo(() => {
        const vistos = new Set<string>();
        const out: { label: string; value: string }[] = [];
        (allTypes || []).forEach((t: any) => {
            const chave = normalizaTermo(t?.label);
            if (!chave || vistos.has(chave)) return;
            vistos.add(chave);
            out.push({ label: String(t.label), value: String(t.value) });
        });
        return out;
    }, [allTypes]);

    // ---- "Onde?": índice montado no 1º foco ----
    const [onde, setOnde] = useState('');
    const [escolha, setEscolha] = useState<Sugestao | null>(null);
    const [bairros, setBairros] = useState<Sugestao[]>([]);
    const ativouRef = useRef(false);

    const indiceBase: Sugestao[] = useMemo(() => {
        const itens: Sugestao[] = [];
        (Array.isArray(allCompany) ? allCompany : []).forEach((c: any) => {
            const label = String(c?.label ?? '').trim();
            if (label) itens.push({ categoria: 'empreendimento', id: Number(c?.value) || 0, label, busca: normalizaTermo(label) });
        });
        (allCities || []).forEach((c: any, i: number) => {
            const label = String(c?.label ?? '').trim();
            if (label) itens.push({ categoria: 'cidade', id: Number(c?.value) || 0, label, busca: normalizaTermo(label), ordem: i });
        });
        return itens;
    }, [allCities, allCompany]);
    const indice = useMemo(() => (bairros.length ? [...bairros, ...indiceBase] : indiceBase), [bairros, indiceBase]);

    const ativarIndice = () => {
        if (ativouRef.current) return;
        ativouRef.current = true;
        const cidades = (allCities || []).filter((c: any) => Number(c?.value) > 0 && c?.label).slice(0, CIDADES_COM_BAIRROS);
        if (!cidades.length) return;
        Promise.all(
            cidades.map((c: any) =>
                district(Number(c.value), origin, codsite)
                    .then((r: any) => ({ cidade: String(c.label), lista: Array.isArray(r?.bairros) ? r.bairros : [] }))
                    .catch(() => ({ cidade: String(c.label), lista: [] as any[] }))
            )
        )
            .then((grupos) => {
                const out: Sugestao[] = [];
                grupos.forEach((g) =>
                    g.lista.forEach((b: any) => {
                        const label = String(b?.nome ?? '').trim();
                        if (!label) return;
                        out.push({ categoria: 'bairro', id: Number(b?.id) || 0, label, sublabel: g.cidade, cidadeLabel: g.cidade, busca: normalizaTermo(`${label} ${g.cidade}`) });
                    })
                );
                if (out.length) setBairros(out);
            })
            .catch(() => undefined);
    };

    const aoEscolher = (s: Sugestao) => {
        setEscolha(s);
        // cidade: o estado do hook passa a valer (URL e pixel saem dele)
        const cidadeDoHook = s.categoria === 'cidade' ? (allCities || []).find((c: any) => normalizaTermo(c?.label) === normalizaTermo(s.label)) : null;
        setCidade(cidadeDoHook ? String(cidadeDoHook.value) : '');
    };
    const limparEscolha = () => {
        setEscolha(null);
        setCidade('');
    };
    // Cidades marcadas no painel "Busca avançada" (Daniel 21/10: várias cidades nos modelos novos): o "Onde?"
    // passa a mostrar o resumo ("Torres" / "2 cidades") e a busca sai do hook, que leva todas elas.
    const cidadesDoPainel = (valor: string) => {
        setCidade(valor);
        setEscolha(null);
        setOnde(resumoMarcados(opcoesDoTexto(allCities, valor).map((c: any) => String(c.label)), 'cidades'));
    };

    // ---- envio ----
    const buscar = (e: React.FormEvent) => {
        const termo = onde.trim();
        // texto solto que não virou escolha: código → busca por código; senão tenta casar com UMA sugestão
        let alvo: Sugestao | null = escolha;
        if (!alvo && termo) {
            if (pareceCodigo(termo)) alvo = { categoria: 'codigo', id: 0, label: termo, busca: normalizaTermo(termo) };
            else {
                const t = normalizaTermo(termo);
                const exatas = indice.filter((s) => s.busca === t || normalizaTermo(s.label) === t);
                const candidatas = exatas.length ? exatas : indice.filter((s) => s.busca.startsWith(t));
                if (candidatas.length === 1) alvo = candidatas[0];
                // referência fora do padrão do pareceCodigo ("R-048", "AP3746838", "S360-669839", "OR72271:112201"):
                // sem sugestão que case, texto sem espaço e com 2+ dígitos é CÓDIGO — antes caía na listagem geral.
                else if (!candidatas.length && REFERENCIA_LIVRE.test(termo)) alvo = { categoria: 'codigo', id: 0, label: termo, busca: t };
            }
        }
        // sem "Onde?", só cidade ou VÁRIAS cidades (marcadas no painel): o hook monta a URL e dispara o Search (fonte única)
        if (!alvo || (alvo.categoria === 'cidade' && escolha) || (!escolha && idsDoTexto(cidade).length > 1)) return onSubmit(e);

        e.preventDefault();
        if (loading) return;
        setLoading(true);
        // tipos marcados (vários: Daniel 21/10) — no caminho com `+`, o contrato da /imoveis
        const tiposEscolhidos = opcoesDoTexto(opcoesTipo, tipo);
        const tipoLabel = tiposEscolhidos.map((t) => t.label).join(', ');
        const tipoSeg = tiposEscolhidos.length ? tiposEscolhidos.map((t) => segmento(t.label, site?.id)).join('+') : '-';
        const cidadeSeg = alvo.categoria === 'cidade' ? segmento(alvo.label, site?.id) : alvo.categoria === 'bairro' ? segmento(alvo.cidadeLabel, site?.id) : '-';
        const bairroSeg = alvo.categoria === 'bairro' ? segmento(alvo.label, site?.id) : '-';
        const condominioSeg = alvo.categoria === 'empreendimento' ? segmento(alvo.label, site?.id) : '-';
        const codigoSeg = alvo.categoria === 'codigo' ? `/${removerAcentos(alvo.label).replaceAll(' ', '%20')}` : '';
        // com CÓDIGO os demais filtros saem da busca (o código já identifica o imóvel)
        let caminho = alvo.categoria === 'codigo' ? `/imoveis/${transacao}/-/-/-/-${codigoSeg}` : `/imoveis/${transacao}/${cidadeSeg}/${bairroSeg}/${condominioSeg}/${tipoSeg}`;
        const max = parseInt(String(precoMax).replace(/\D/g, ''), 10);
        if (alvo.categoria !== 'codigo' && max > 0) caminho = `${caminho}?min=0&max=${max}`;

        const eventId = genMetaEventId();
        try {
            sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() }));
        } catch {
            /* sessionStorage indisponível — Search sai sem dedup c/ CAPI */
        }
        trackMetaEvent(site, 'Search', { search_string: [transacao, tipoLabel, alvo.label].filter(Boolean).join(' | '), transaction_type: transacao, property_type: tipoLabel, city: alvo.categoria === 'cidade' ? alvo.label : alvo.cidadeLabel || '' }, { eventId });
        router.push(finalize(caminho)).catch(() => setLoading(false));
    };

    return (
        <section className={`${styles.larissa} ${reduzido ? styles.semMovimento : ''}`} data-builder-section="busca" style={varsLarissa(site)}>
            <DrawerComponent site={site} activeDrawer={activeDrawer} setActiveDrawer={setActiveDrawer} favorito={favorito || []} menus={props?.menus} />

            {/* ---------- herói: só mídia ---------- */}
            <div className={styles.heroi} aria-hidden="true">
                {videoSrc ? (
                    <video className={styles.midia} autoPlay={!videoParado} muted loop playsInline preload="none" poster={heroPoster || (bannerSrc ? bannerSrc : undefined)} src={heroPoster ? (heroVideoReady ? videoSrc : undefined) : videoSrc}>
                        <track kind="captions" label="Legenda" src="legenda.vtt" />
                    </video>
                ) : bannerSrc ? (
                    <img className={styles.midia} src={bannerSrc} alt="" fetchPriority="high" decoding="async" draggable={false} />
                ) : (
                    <HeroVideoCover src={capaVideo} className={styles.midia} fallbackClassName={styles.midiaReserva} />
                )}
                <span className={styles.degrade} />
            </div>

            {/* ---------- cartão de busca sobreposto ---------- */}
            <div className={styles.conteudo}>
                <div className={styles.cartao}>
                    {/* id="myLink": âncora do botão "BUSCA AVANÇADA" do topo 2. */}
                    <form id="myLink" className={styles.form} onSubmit={buscar} role="search" aria-label="Busca de imóveis">
                        <div className={styles.cabeca}>
                            <h1 className={styles.titulo}>{titulo}</h1>
                            <div className={styles.onde}>
                                <SmartLocationSearch
                                    indice={indice}
                                    estado="pronto"
                                    onAtivar={ativarIndice}
                                    valor={onde}
                                    onChangeValor={setOnde}
                                    onEscolher={aoEscolher}
                                    onLimparEscolha={limparEscolha}
                                    placeholder="Onde? Bairro, cidade, condomínio ou código"
                                    ariaLabel="Onde você procura: bairro, cidade, condomínio ou código"
                                    limitePorGrupo={8}
                                    className={styles.campoBusca}
                                />
                                <button type="submit" className={styles.lupa} aria-label="Buscar imóveis" disabled={loading}>
                                    <IconeLupa />
                                </button>
                            </div>
                        </div>

                        <span className={styles.regua} aria-hidden="true" />

                        <div className={styles.corpo}>
                            <div className={styles.ladrilhos} role="radiogroup" aria-label="O que você procura">
                                {transacoes.map((t: any) => {
                                    const valor = String(t.value).toLowerCase();
                                    const ativo = valor === transacao;
                                    return (
                                        <button key={valor} type="button" role="radio" aria-checked={ativo} className={`${styles.ladrilho} ${ativo ? styles.ladrilhoAtivo : ''}`} onClick={() => setTransacao(valor)}>
                                            <IconeTransacao valor={valor} />
                                            <span>{t.label}</span>
                                        </button>
                                    );
                                })}
                            </div>

                            <div className={styles.campo}>
                                <span className={styles.rotulo}>Tipo de imóvel</span>
                                <div className={styles.controle}>
                                    <CampoSelecaoMulti opcoes={opcoesTipo} valor={tipo} onChange={setTipo} rotuloVazio="Todos os tipos" plural="tipos" ariaLabel="Tipo de imóvel" className={styles.campoBusca} />
                                </div>
                            </div>

                            <label className={styles.campo}>
                                <span className={styles.rotulo}>Valor até</span>
                                <div className={styles.controle}>
                                    <span className={styles.moeda} aria-hidden="true">
                                        {moeda}
                                    </span>
                                    <input className={styles.input} type="text" inputMode="numeric" autoComplete="off" placeholder="Sem limite" value={precoMax} onChange={(e) => setPrecoMax(agrupaMilhar(e.target.value.replace(/\D/g, '')))} aria-label="Valor máximo" />
                                </div>
                            </label>
                        </div>

                        <div className={styles.pe}>
                            <button type="button" className={styles.avancada} aria-haspopup="dialog" onClick={abrirAvancada}>
                                <IconeFiltros />
                                Busca avançada
                            </button>
                            <button type="submit" className={styles.buscar} disabled={loading}>
                                <span>{loading ? 'Buscando…' : 'Buscar'}</span>
                                <IconeSeta />
                            </button>
                        </div>
                    </form>
                </div>

                <CardsBusca cards={allCards} site={site} variante="claro" className={styles.cards} />
            </div>

            <BuscaAvancadaAurora
                variante="larissa"
                aberto={avancadaAberta}
                onFechar={fecharAvancada}
                site={site}
                origin={origin}
                codsite={codsite2}
                allCities={allCities || []}
                allTypes={allTypes || []}
                allCompany={allCompany}
                basico={{ transacao, cidade, tipo, dormitorios }}
                setDormitorios={setDormitorios}
                cidadesNoPainel
                setCidade={cidadesDoPainel}
                finalize={finalize}
                onBuscar={buscarAvancada}
                corAcao={paleta.base}
                corAcaoTexto="#ffffff"
                corTexto={paleta.tinta}
            />
        </section>
    );
};

class WelcomeLarissa extends React.Component<HeroSectionProps, { hasError: boolean }> {
    constructor(props: HeroSectionProps) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch() {
        // silencioso: degrada pro fallback sem quebrar a home.
    }
    render() {
        const { fallback, site } = this.props;
        if (this.state.hasError || !site) return fallback ?? null;
        return <WelcomeLarissaInner {...this.props} />;
    }
}

export default WelcomeLarissa;
